<div class="card add-margin">
  <div class="card-header">
    <div class="row">
      <div class="col-sm-10">
      </div>
      <div class="col-sm-2">
        <button class="btn btn-secondary float-end" (click)="cancelar()">Volver</button>
      </div>
    </div>
  </div>
  <div class="card-body container border">
    <h2>Recepción de combustible</h2>
    <form [formGroup]="recepcionForm">
      <div class="container etapa-section">
        <h3 class="mb-4 mt-4">Etapa 1: Datos según remito</h3>

        <div class="row mb-3">
          <div class="col-sm-5">
            <label for="terminal" class="col-form-label fw-bold">Terminal:</label>
          </div>
          <div class="col-sm-7">
            <select id="terminal" class="form-select" formControlName="terminal">
              <option *ngFor="let t of terminales" [ngValue]="t">{{ t.nombre }}</option>
            </select>
          </div>
        </div>

        <div class="row mb-3 align-items-center">
          <div class="col-sm-1">
            <label for="remitoFisico" class="col-form-label">Remito físico:</label>
          </div>
          <div class="col-sm-6">
            <app-upload-file [url]="this.stockBaseUrl" (archivoSubido)="onArchivoSubido($event)"></app-upload-file>
          </div>
          <div class="col-sm-4">
            <div class="alert alert-warning p-2 mb-0">
              Aclaración: es necesario firmar el remito físico antes de subir la imagen
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-6 d-flex align-items-center">
            <label for="prefijoRemito" class="col-sm-4 col-form-label">Prefijo remito cargamento:</label>
            <div class="col-sm-8">
              <input appOnlyNumber type="text" class="form-control" id="prefijoRemito" formControlName="prefijoRemito">
              <div
                *ngIf="prefijoRemito.invalid && prefijoRemito.errors.required && (prefijoRemito.dirty || prefijoRemito.touched)"
                class="alert alert-danger mt-1">Requerido</div>
              <div
                *ngIf="prefijoRemito.invalid && prefijoRemito.errors.prefijoMenor4 && (prefijoRemito.dirty || prefijoRemito.touched)"
                class="alert alert-danger mt-1">El prefijo no puede exceder los 4 dígitos</div>
            </div>
          </div>

          <div class="col-sm-6 d-flex align-items-center">
            <label for="numeroRemito" class="col-sm-4 col-form-label">Número remito cargamento:</label>
            <div class="col-sm-8">
              <input appOnlyNumber type="text" class="form-control" id="numeroRemito" formControlName="numeroRemito">
              <div
                *ngIf="numeroRemito.invalid && numeroRemito.errors.required && (numeroRemito.dirty || numeroRemito.touched)"
                class="alert alert-danger mt-1">Requerido</div>
              <div
                *ngIf="numeroRemito.invalid && numeroRemito.errors.numeroMenor8 && (numeroRemito.dirty || numeroRemito.touched)"
                class="alert alert-danger mt-1">El número de remito no puede exceder los 8 dígitos</div>
            </div>
          </div>
        </div>

        <h4>Datos del transportista</h4>
        <div class="row">
          <!-- Columna izquierda (misma que conductor) -->
          <div class="col-sm-6">
            <div class="row mb-2 align-items-center">
              <div class="col-sm-3">
                <label for="cuitTransportista" class="col-form-label">CUIT transportista:</label>
              </div>
              <div class="col-sm-9">
                <input id="cuitTransportista" type="text" class="form-control" formControlName="cuitTransportista"
                  [inputFormatter]="formatterTransportistaInput" [resultFormatter]="formatterTransportistaResult"
                  title="Campo obligatorio, debe seleccionar o ingresar un transportista."
                  (selectItem)="selectTransportista($event)" [ngbTypeahead]="searchTransportista"
                  [(ngModel)]="modelTransportista" />
                <loading-text-spinner *ngIf="cargandoTransportistas" [error]="errorTransportistas"
                  message="Obteniendo Transportistas..." color="primary"></loading-text-spinner>
                <div
                  *ngIf="cuitTransportista.invalid && cuitTransportista.errors.required && (cuitTransportista.dirty || cuitTransportista.touched)"
                  class="alert alert-danger mt-1">Requerido</div>
                <div *ngIf="cuitTransportista.invalid && (cuitTransportista.dirty || cuitTransportista.touched)"
                  class="alert alert-danger mt-1">El número de CUIT no tiene el formato correcto.</div>
              </div>
            </div>

            <div class="row mb-2 align-items-center">
              <div class="col-sm-3">
                <label for="nombreTransportista" class="col-form-label">Nombre transportista:</label>
              </div>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="nombreTransportista" formControlName="nombreTransportista">
                <div
                  *ngIf="nombreTransportista.invalid && nombreTransportista.errors.required && (nombreTransportista.dirty || nombreTransportista.touched)"
                  class="alert alert-danger mt-1">Requerido</div>
              </div>
            </div>

            <div class="row mb-2 align-items-center">
              <div class="col-sm-3">
                <label for="domicilioTransportista" class="col-form-label">Domicilio transportista:</label>
              </div>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="domicilioTransportista"
                  formControlName="domicilioTransportista">
                <div
                  *ngIf="domicilioTransportista.invalid && domicilioTransportista.errors.required && (domicilioTransportista.dirty || domicilioTransportista.touched)"
                  class="alert alert-danger mt-1">Requerido</div>
              </div>
            </div>
          </div>

          <!-- Columna derecha vacía para replicar layout del conductor -->
          <div class="col-sm-6"></div>
        </div>


        <!-- Datos del conductor -->
        <h4>Datos del conductor</h4>
        <div class="row">
          <div class="col-sm-6">
            <div class="row mb-2">
              <div class="col-sm-3">
                <label for="dniConductor" class="col-form-label">DNI:</label>
              </div>
              <div class="col-sm-9">
                <input id="dniConductor" type="text" class="form-control" formControlName="dniConductor"
                  [inputFormatter]="formatterConductorInput" [resultFormatter]="formatterConductorResult"
                  title="Campo obligatorio, debe seleccionar o ingresar un conductor."
                  (selectItem)="selectConductor($event)" [ngbTypeahead]="searchConductor" appOnlyNumber
                  [(ngModel)]="modelConductor" />
                <loading-text-spinner *ngIf="cargandoConductores" [error]="errorConductores"
                  message="Obteniendo Conductores..." color="primary"></loading-text-spinner>
                <div
                  *ngIf="dniConductor.invalid && dniConductor.errors.required && (dniConductor.dirty || dniConductor.touched)"
                  class="alert alert-danger mt-1">Requerido</div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-sm-3">
                <label for="nombreConductor" class="col-form-label">Nombre conductor:</label>
              </div>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="nombreConductor" formControlName="nombreConductor">
                <div
                  *ngIf="nombreConductor.invalid && nombreConductor.errors.required && (nombreConductor.dirty || nombreConductor.touched)"
                  class="alert alert-danger mt-1">Requerido</div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-sm-3">
                <label for="patenteCamion" class="col-form-label">Patente tractor:</label>
              </div>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="patenteCamion" formControlName="patenteCamion">
                <div
                  *ngIf="patenteCamion.invalid && patenteCamion.errors.required && (patenteCamion.dirty || patenteCamion.touched)"
                  class="alert alert-danger mt-1">Requerido</div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-sm-3">
                <label for="patenteAcoplado" class="col-form-label">Patente acoplado:</label>
              </div>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="patenteAcoplado" formControlName="patenteAcoplado">
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="row mb-2">
              <div class="col-sm-4">
                <label for="precintoFijo" class="col-form-label">Precinto fijo:</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="precintoFijo" formControlName="precintoFijo">
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-sm-4">
                <label for="precintoDesde" class="col-form-label">Precinto desde:</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="precintoDesde" formControlName="precintoDesde">
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-sm-4">
                <label for="precintoHasta" class="col-form-label">Precinto hasta:</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="precintoHasta" formControlName="precintoHasta">
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--
        ETAPA 2 - Apto calidad
      -->
      <div formArrayName="calidadProducto">
        <div class="container etapa-section" *ngFor="let producto of productos; let iCalidad = index;"
          [formGroupName]="iCalidad">
          <h3 class="mb-4 mt-4">Etapa 2: Apto calidad - Producto: {{ producto.nombreProducto }}</h3>

          <h4>Datos según remito</h4>
          <div class="row align-items-start">
            <!-- COLUMNA IZQUIERDA -->
            <div class="col-sm-6">
              <!-- DATOS SEGÚN REMITO -->
              <div class="row mb-2">
                <div class="col-sm-3">
                  <label for="densidadRemito" class="col-form-label">Densidad (g/cm³):</label>
                </div>
                <div class="col-sm-9">
                  <input class="form-control" formControlName="densidadRemito"
                    (keyup)="obtenerDiferenciaDensidad(iCalidad)" (keypress)="formatDensidadRemito($event, iCalidad)">
                  <div
                    *ngIf="producto.densidadMin && producto.densidadMax && !this.validarDensidad(this.calidadProducto.at(iCalidad).get('densidadRemito').value, iCalidad)"
                    class="alert alert-warning mt-1">
                    La densidad debe estar en el rango [{{ productos[iCalidad].densidadMin | number:'1.3-3' }},
                    {{ productos[iCalidad].densidadMax | number:'1.3-3' }}]
                  </div>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-sm-3">
                  <label for="volumen15Remito" class="col-form-label">Volumen 15°C:</label>
                </div>
                <div class="col-sm-9">
                  <input type="text" appNumericFormatter [decimals]="0" class="form-control" id="volumen15Remito"
                    formControlName="volumen15Remito">
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-3">
                  <label for="volumenNaturalRemito" class="col-form-label">Volumen natural:</label>
                </div>
                <div class="col-sm-9">
                  <input type="text" appNumericFormatter [decimals]="0" class="form-control" id="volumenNaturalRemito"
                    formControlName="volumenNaturalRemito">
                </div>
              </div>

              <!-- DATOS SEGÚN MUESTRA -->
              <h4 class="mt-3">Datos según muestra</h4>

              <div class="row mb-3">
                <div class="col-sm-3">
                  <label for="temperaturaMuestra" class="col-form-label">
                    Temperatura:
                  </label>
                </div>

                <div class="col-sm-9">
                  <input type="text" class="form-control" (change)="chequearCalidadProductoValido(iCalidad)"
                    (keyup)="obtenerDiferenciaDensidad(iCalidad)" id="temperaturaMuestra" appOnlyDecimalNegativa
                    formControlName="temperaturaMuestra">
                  <div
                    *ngIf="this.calidadProducto.at(iCalidad).get('temperaturaMuestra').invalid && this.calidadProducto.at(iCalidad).get('temperaturaMuestra').errors.required && (this.calidadProducto.at(iCalidad).get('temperaturaMuestra').dirty || this.calidadProducto.at(iCalidad).get('temperaturaMuestra').touched)"
                    class="col-md-12 alert alert-danger">Requerido</div>
                  <div
                    *ngIf="this.calidadProducto.at(iCalidad).get('temperaturaMuestra').invalid && !this.calidadProducto.at(iCalidad).get('temperaturaMuestra').errors.required && this.calidadProducto.at(iCalidad).get('temperaturaMuestra').errors.invalidNumber && (this.calidadProducto.at(iCalidad).get('temperaturaMuestra').dirty || this.calidadProducto.at(iCalidad).get('temperaturaMuestra').touched)"
                    class="col-md-12 alert alert-danger">Temperatura no es válida</div>
                  <div
                    *ngIf="(this.calidadProducto.at(iCalidad).get('temperaturaMuestra').value>100 || this.calidadProducto.at(iCalidad).get('temperaturaMuestra').value<-50) "
                    class="col-md-12 alert alert-warning">Debe elegir una temperatura entre -50 y 100 grados</div>
                </div>

              </div>
              <div class="row mb-3">
                <div class="col-sm-3">
                  <label for="densidadMuestra" class="col-form-label">Densidad (g/cm³):</label>
                </div>
                <div class="col-sm-9">
                  <input class="form-control" formControlName="densidadMuestra"
                    (keyup)="obtenerDiferenciaDensidad(iCalidad)" (keypress)="formatDensidadMuestra($event, iCalidad)">
                  <div
                    *ngIf="producto.densidadMin && producto.densidadMax && !this.validarDensidad(this.calidadProducto.at(iCalidad).get('densidadMuestra').value, iCalidad)"
                    class="alert alert-warning mt-1">
                    La densidad debe estar en el rango [{{ productos[iCalidad].densidadMin | number:'1.3-3' }},
                    {{ productos[iCalidad].densidadMax | number:'1.3-3' }}]
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-4">
                  <label for="diferenciaDensidad" class="col-form-label">Diferencia densidad:</label>
                </div>
                <div class="col-sm-3">
                  <input type="text" class="form-control" id="diferenciaDensidad" formControlName="diferenciaDensidad"
                    readonly>
                </div>
                <div class="col-sm-2">
                  <label for="tolerancia" class="col-form-label">Tolerancia:</label>
                </div>
                <div class="col-sm-3">
                  <input type="text" class="form-control" id="tolerancia" placeholder="0,004"
                    formControlName="tolerancia" readonly>
                </div>
              </div>
            </div>

            <!-- COLUMNA DERECHA -->
            <div class="col-sm-6">
              <h4>Aspecto visual</h4>

              <div class="row mb-2">
                <div class="col-sm-5">
                  <label for="indicadorContaminantesSolidos" class="col-form-label">Contaminantes sólidos:</label>
                </div>
                <div class="col-sm-7">
                  <select id="indicadorContaminantesSolidos" class="form-select"
                    formControlName="indicadorContaminantesSolidos">
                    <option value="1">1 Claro (limpio)</option>
                    <option value="2">2 Pequeñas partículas sólidas</option>
                    <option value="3">3 Partículas sólidas</option>
                    <option value="4">4 Sucio</option>
                  </select>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-5">
                  <label for="indicadorHumedad" class="col-form-label">Indicador de humedad:</label>
                </div>
                <div class="col-sm-7">
                  <select id="indicadorHumedad" class="form-select" formControlName="indicadorHumedad">
                    <option value="A">A Brillante (seco)</option>
                    <option value="B">B Neblinoso</option>
                    <option value="C">C Turbio</option>
                    <option value="D">D Húmedo (agua libre)</option>
                    <option value="E">E Surfactantes</option>
                  </select>
                </div>
              </div>

              <!-- CERTIFICADO Y CONDUCTIVIDAD -->
              <div class="row mt-3 mb-2">
                <div class="col-sm-4">
                  <label for="nroCertificadoAnalisis" class="col-form-label">N° certificado de análisis:</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="nroCertificadoAnalisis"
                    formControlName="nroCertificadoAnalisis">
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-sm-4">
                  <label for="conductividad" class="col-form-label">Conductividad:</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" appOnlyNumber class="form-control" id="conductividad"
                    formControlName="conductividad">
                </div>
              </div>
              <div class="text-center mb-3">
                <button [disabled]="!producto.puedeAgregarPurga"
                  (click)="agregarPurga(iCalidad); verificarApto(iCalidad)" class="btn btn-primary">Agregar</button>
              </div>

              <div *ngIf="recepcion.detalleProductos[iCalidad].calidadProducto">
                Resultado purga: {{recepcion.detalleProductos[iCalidad].calidadProducto.resultadoPurga}}
              </div>

              <div *ngIf="!verificarApto(iCalidad)" class="alert alert-warning mt-2">
                Atención, el producto no es apto calidad.
              </div>
              <div *ngIf="!verificarApto(iCalidad)" class="mt-2">
                <button class="btn btn-sm btn-danger" (click)="noRecibirProducto(iCalidad)">
                  No recibir producto
                </button>
              </div>
            </div>
          </div>

          <!-- PRUEBA DE AGUA -->
          <div class="p-2 mt-4">
            <div class="row">
              <div class="col-sm-3">
                <label for="pruebaAgua" class="col-form-label">Prueba de agua:</label>
              </div>
              <div class="col-sm-9">
                <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioPruebaAgua"
                  id="radioPruebaAgua{{iCalidad}}">
                  <input ngbButton type="radio" class="btn-check" [value]="true" formControlName="pruebaAgua"
                    id="pruebaAguaPositiva{{iCalidad}}" />
                  <label ngbButtonLabel class="btn-outline-primary btn"
                    for="pruebaAguaPositiva{{iCalidad}}">Positiva</label>

                  <input ngbButton type="radio" class="btn-check" [value]="false" formControlName="pruebaAgua"
                    id="pruebaAguaNegativa{{iCalidad}}" />
                  <label ngbButtonLabel class="btn-outline-primary btn"
                    for="pruebaAguaNegativa{{iCalidad}}">Negativa</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 alert alert-danger mt-2" *ngIf="!pruebaAguaPositiva(iCalidad)">
                El resultado de la prueba de agua debe ser Negativo para poder continuar.
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--
        ETAPA 3 - Datos de cisterna
      -->
      <div formArrayName="detalleCisternas">
        <div class="container etapa-section" *ngFor="let producto of productos; let i = index" [formGroupName]="i">
          <div>
            <h3 class="mb-4 mt-4">
              Etapa 3: Datos de cisterna - Producto: {{ producto.nombreProducto }}
              {{ !producto.recibeProducto ? '- RECHAZADO' : '' }}
            </h3>

            <table class="table table-sm table-striped text-center" *ngIf="getCisternas(i).length > 0">
              <thead>
                <tr>
                  <th>Cisterna</th>
                  <th>Cantidad Natural</th>
                  <th>Cantidad a 15°</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let cisterna of getCisternas(i).controls; let j = index" [formGroupName]="j">
                  <td class="text-center">{{ cisterna.get('codigo')?.value }}</td>
                  <td class="text-center">{{ cisterna.get('volumen')?.value | number:'1.0-3' }}</td>
                  <td class="text-center">{{ cisterna.get('volumen15')?.value | number:'1.0-3' }}</td>
                  <td class="text-center">
                    <button type="button" class="btn m-1"
                      [ngClass]="{'btn-success': cisternaEstados[i]?.[j] === EstadoCisterna.RECIBIDO,'btn-outline-success': cisternaEstados[i]?.[j] !== EstadoCisterna.RECIBIDO}"
                      [disabled]="cisternasConfirmadas[i]" (click)="toggleRecibirCisterna(i, j)">
                      Recibir
                    </button>

                    <button type="button" class="btn m-1"
                      [ngClass]="{'btn-danger': cisternaEstados[i]?.[j] === EstadoCisterna.RECHAZADO,'btn-outline-danger': cisternaEstados[i]?.[j] !== EstadoCisterna.RECHAZADO}"
                      [disabled]="cisternasConfirmadas[i]" (click)="toggleRechazarCisterna(i, j)">
                      Rechazar
                    </button>

                    <button type="button" class="btn btn-outline-secondary m-1" *ngIf="!recepcionCenit"
                      [disabled]="cisternasConfirmadas[i]" (click)="eliminarCisterna(i, j)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>

                </tr>

                <tr class="fw-bold">
                  <td>Totales</td>
                  <td>{{ totales[i]?.natural | number: '1.0-3' }}</td>
                  <td>{{ totales[i]?.a15 | number: '1.0-3' }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div class="alert alert-danger mt-2" *ngIf="getDiferenciasVolumen(i) as dif">
              Los montos ingresados no coinciden con los declarados en el remito original<br>
              Por favor revise los datos ingresados. <br>
              Diferencia natural: {{ dif.diferenciaNatural | number:'1.0-3' }}<br>
              Diferencia a 15°: {{ dif.diferenciaA15 | number:'1.0-3' }}
            </div>

            <div class="d-flex justify-content-between mt-3">
              <div>
                <button *ngIf="!recepcionCenit" class="btn btn-outline-primary me-2" [disabled]="!verificarApto(i)"
                  (click)="abrirModalAgregarMedicion(i)">
                  Agregar medición de cisterna
                </button>

                <button class="btn btn-primary" [disabled]="!getCisternas(i).length" (click)="recibirTotal(i)">
                  Recibir total
                </button>
              </div>

              <div>
                <button class="btn btn-success"
                  [disabled]="cisternasConfirmadas[i] || !verificarApto(i) || !coincidenTotalesConRemito(i)"
                  (click)="confirmarCisternas(i)" *ngIf="getCisternas(i).length > 0">
                  Confirmar cisternas
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--
        ETAPA 4 - Medicion inicial
      -->
      <div formArrayName="medicionInicial">
        <div class="containers etapa-section" *ngFor="let producto of productos; let i = index" [formGroupName]="i">
          <div>
            <h3 class="mb-4 mt-4">Etapa 4: Medición inicial - Producto: {{ producto.nombreProducto }}
              {{!producto.recibeProducto ? "- RECHAZADO" : ""}}</h3>
            <h5>Datos según remito</h5>
            <div class="row">
              <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-3"> <label for="volumenNaturalRemitoMedicionInicial" class="col-form-label">
                      Volumen Natural: </label> </div>
                  <div class="col-sm-9"> <input type="text" class="form-control text-end" appNumericFormatter
                      id="volumenNaturalRemitoMedicionInicial" formControlName="volumenNaturalRemitoMedicionInicial" />

                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-3"> <label for="volumen15RemitoMedicionInicial" class="col-form-label"> Volumen
                      15ºC: </label> </div>
                  <div class="col-sm-9"> <input type="text" appNumericFormatter [decimals]="0" class="form-control"
                      id="volumen15RemitoMedicionInicial" formControlName="volumen15RemitoMedicionInicial"> </div>
                </div>
              </div>
            </div>

            <h5>Mediciones y carga de tanques</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="container border m-3 p-2"
                  *ngFor="let medicion of producto.medicionesIniciales; let iMedicion = index">
                  <h5>Datos medición para tanque: {{ medicion.tanque }}</h5>
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="col-sm-6">
                        <label class="col-form-label" for="volumenDatosMedicionInicial">Volumen natural: {{
                          medicion.nivelNatural | number:'1.0-3' }}</label>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="col-sm-6">
                        <label for="vacioDatosMedicionInicial" class="col-form-label">Vacío: {{ medicion.vacio
                          }}</label>
                      </div>
                    </div>
                    <div class="col-sm-1">
                      <button *ngIf="!validarMedicionPrevia(i)" (click)="borrarMedicionPrevia(medicion, i, iMedicion)"
                        class="btn btn-sm btn-danger">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="col-sm-3">
                        <label class="col-form-label" for="volumenNaturalAIngresarMedicionInicial{{iMedicion}}">Volumen
                          a ingresar:
                        </label>
                      </div>
                      <div class="col-sm-3">
                        <input class="form-control" appNumericFormatter [decimals]="0"
                          [ngModel]="medicion.medicionNaturalAIngresar"
                          (ngModelChange)="setMedicionNaturalAIngresar($event, i, iMedicion)"
                          [ngModelOptions]="{ standalone: true }" />

                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="col-sm-3">
                        <label for="volumen15AIngresarMedicionInicial{{i}}" class="col-form-label">Volumen 15º a
                          ingresar</label>
                      </div>
                      <div class="col-sm-3">
                        <input class="form-control" appNumericFormatter [decimals]="0"
                          [ngModel]="medicion.medicion15AIngresar"
                          (ngModelChange)="setMedicion15AIngresar($event, i, iMedicion)"
                          [ngModelOptions]="{ standalone: true }" />

                      </div>
                    </div>

                  </div>
                  <div class="row" *ngIf="noCoincideMedicion(i)">
                    <div class="col-sm-12 mt-2">
                      <div class="alert alert-danger">
                        La suma de los volúmenes a ingresar no coincide a la totalidad del remito, por favor revise los
                        datos ingresados o agregue otra medición inicial.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 text-center m-3">
                    <button class="btn btn-primary"
                      [disabled]="!producto.recibeProducto ||!verificarApto(i) ||obteniendoAeroplanta ||!todasCisternasConfirmadas()"
                      (click)="agregarMedicionInicial(i)">
                      Agregar
                    </button>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
        ETAPA 5 - Medicion final
      -->
      <div formArrayName="medicionFinal">
        <div class="container etapa-section" *ngFor="let producto of productos; let i = index" [formGroupName]="i">
          <div>
            <h3 class="mb-4 mt-4">Etapa 5: Medición final - Producto: {{ producto.nombreProducto }}
              {{!producto.recibeProducto ? "- RECHAZADO" : ""}} </h3>
            <h5>Datos según remito</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-2"> <label for="volumen15RemitoMedicionFinal" class="col-form-label"> Volumen
                      15ºC: </label> </div>
                  <div class="col-sm-4"> <input appNumericFormatter appFormattype="text" class="form-control"
                      id="volumen15RemitoMedicionFinal" formControlName="volumen15RemitoMedicionFinal"> </div>
                  <div class="col-sm-1"> <label for="densidadRemitoMedicionFinal" class="col-form-label">
                      Densidad (g/cm3): </label> </div>
                  <div class="col-sm-2"> <input type="text" class="form-control" id="densidadRemitoMedicionFinal"
                      [value]="sharedService.formatDensidadRemitoAuto(calidadProducto.at(i).get('densidadRemito')?.value)"
                      disabled>
                  </div>
                  <div class="col-sm-1" style="display: none"> <label for="temperaturaRemitoMedicionFinal"
                      class="col-form-label">
                      Temperatura: </label> </div>
                  <div class="col-sm-2" style="display: none"> <input type="text" class="form-control"
                      id="temperaturaRemitoMedicionFinal" formControlName="temperaturaRemitoMedicionFinal">
                  </div>
                </div>
              </div>
            </div>

            <h5>Datos según medición</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="container border m-3 p-2"
                  *ngFor="let medicion of producto.medicionesFinales; let iMedicion = index">
                  <h5>Datos medición para tanque: {{ medicion.tanque }}</h5>
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="col-sm-6">
                        <label class="col-form-label" for="volumenNaturalDatosMedicionFinal">Volumen natural: {{
                          medicion.nivelNatural | number:'1.0-3' }}</label>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="col-sm-6">
                        <label for="vacioDatosMedicionFinal" class="col-form-label">Vacío: {{ medicion.vacio |
                          number:'1.0-3' }}</label>
                      </div>

                    </div>
                    <div class="col-sm-1">
                      <button (click)="borrarMedicionFinal(medicion, i, iMedicion)" class="btn btn-sm btn-danger">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="text-center col-sm-12 m-3">
                    <button class="btn btn-primary" [disabled]="this.producto.medicionesIniciales.length == 0"
                      (click)=agregarMedicionFinal(i)>Agregar</button>
                  </div>
                </div>
              </div>

              <h5>Comparativa remito-medición</h5>
              <div class="row">
                <div class="col-sm-6">
                  <div class="row">
                    <div>
                      <label class="col-form-label">
                        Total medición a 15ºC:
                        {{ getTotalMedicion15(i) | number:'1.0-3' }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <div>
                      <label class="col-form-label">
                        Diferencia:
                        {{ getDiferenciaMedicion15(i) | number:'1.0-3' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
      <div>
        <button [disabled]="cargandoRecepcion" class="btn btn-primary float-end" (click)="cargarRecepcion()">
          <span *ngIf="!cargandoRecepcion">Guardar</span>
          <div *ngIf="cargandoRecepcion" class="d-flex align-items-center">
            <div class="spinner-border text-light spinner-border-sm" role="status"></div>
            <span>Guardando...</span>
          </div>
        </button>
      </div>
    </form>
  </div>
</div>